import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
// 从组件或父组件ptag选项里获取ptag
function getPtagFromContext(context) {
  // 通过Vue组件reportModule参数定义组件和子组件的f_module
  if (context.$options['ptag']) {
    return context.$options['ptag'];
  } else if (context.$parent) {
    return getPtagFromContext(context.$parent);
  } else {
    return undefined;
  }
}
var tenvideoModule = function tenvideoModule() {
  return import('@tencent/vft-common/tenvideo');
};
var utilModule = function utilModule() {
  return import('@tencent/vft-common/util');
};
export default {
  methods: {
    openUrl: function () {
      var _openUrl = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var tenvideo, util, ptag;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return tenvideoModule();
              case 2:
                tenvideo = _context.sent.default;
                _context.next = 5;
                return utilModule();
              case 5:
                util = _context.sent.default;
                // 设置ptag
                if (!util.getUrlParam('ptag', url)) {
                  ptag = getPtagFromContext(this);
                  if (ptag) {
                    url = util.setUrlParam('ptag', 'fuli.' + ptag, url);
                  }
                }
                if (tenvideo.isAllTenvideo()) {
                  tenvideo.openUrlCommonActivity(url);
                } else {
                  if (navigator.userAgent.indexOf('Chrome') >= 0) {
                    window.open(url);
                  } else {
                    window.location.href = url;
                  }
                }
              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function openUrl(_x) {
        return _openUrl.apply(this, arguments);
      }
      return openUrl;
    }()
  }
};